import { useQuery } from '@tanstack/react-query';
import { API } from 'utils/globalApiServices';
import { useRealplayStore } from 'features/realplays/RealPlays.store';

const queryFn = async () => {
  const url = `/ai/attitudes/`;
  const { data } = await API.getTemporary(url);
  return data || [];
};

const useGetAttitudeListQuery = ({ active }) => {
  const { setAttitudes } = useRealplayStore();
  return useQuery({
    queryFn: () => queryFn(),
    queryKey: ['ATTITUDES_INFO_AI'],
    enabled: active,
    onSuccess: (response) => {
      const list = response?.attitudes.map((x) => ({
        ...x,
        isSelected: x?.name === 'Friendly' ? true : false,
      }));
      setAttitudes(list);
    },
  });
};

export default useGetAttitudeListQuery;
